import CallToAction from "@/components/molecules/headers/details-page/CallToAction";
import useShowHeaderActionInfo from "@/hooks/useShowHeaderActionInfo";
import { domElementIds } from "@/styles/constants";
import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import useDetailPageTabHeight from "@app-contexts/public/features/event-detail/hooks/useDetailPageTabHeight";
import { PublicVenueSerializer } from "@app-contexts/public/features/org-profile/data/types/public-venue";
import Grid from "@ui-kit/layout/Grid/Grid.web";
import GridItem from "@ui-kit/layout/GridItem/GridItem.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { enums, PAYMENT_TYPE_OPTIONS_MAP } from "@shared/constants";
import usePublicMembershipGroupsService from "@shared/modules/memberships/data/services/usePublicMembershipGroupsService";
import { useRouter } from "next/router";
import { Dispatch, SetStateAction } from "react";
import { MembershipDetailsHeader } from "@app/core/src/shared/modules/memberships/components/MembershipDetailsHeader/MembershipDetailsHeader";
import HeaderAction from "./HeaderAction";
import HeaderTabs from "./HeaderTabs";

const { headerTabsId } = domElementIds;

type MembershipTab = {
  id: number;
  title?: string;
  showTab: boolean;
  hash?: string;
};

// TODO: This looks like a copy of EventDetailsHeader and some
// Generic can probably be made instead
export default function MembershipDetailsHeaderAndTabs({
  membershipTabOptions,
  selectedTab,
  setSelectedTab,
  isSmallerThanSm,
  isTablet,
  isReactNativeApp,
  venue,
  openModal,
}: {
  membershipTabOptions: MembershipTab[];
  selectedTab: number;
  setSelectedTab: Dispatch<SetStateAction<number>>;
  isSmallerThanSm: boolean;
  isTablet: boolean;
  isReactNativeApp: boolean;
  venue: PublicVenueSerializer;
  openModal: () => void;
}) {
  const router = useRouter();
  const { hasItems } = usePublicBasket();
  const tabHeight = useDetailPageTabHeight(hasItems);
  const showHeaderActionInfo = useShowHeaderActionInfo();
  const membershipGroupParams = {
    purchase_platform: enums.PURCHASE_SOURCE_PLATFORM_MAP.PLATFORM_WEB.id,
    payment_type: [
      PAYMENT_TYPE_OPTIONS_MAP.CREDIT.id,
      PAYMENT_TYPE_OPTIONS_MAP.AFTERPAY.id,
      PAYMENT_TYPE_OPTIONS_MAP.AFFIRM.id,
    ].toString(),
  };

  const { useRetrieve } = usePublicMembershipGroupsService();
  const { data: membershipGroupData, isLoading } = useRetrieve(
    String(router?.query?.membershipSlug),
    {
      config: { params: membershipGroupParams },
      options: {
        enabled: Boolean(
          router?.query?.membershipSlug && membershipGroupParams
        ),
      },
    }
  );

  if (!membershipGroupData) {
    return null;
  }

  return (
    <>
      <MembershipDetailsHeader
        venue={venue}
        membershipGroupData={membershipGroupData}
        isTablet={isTablet}
        isLoading={isLoading}
      />
      <Flex
        position="sticky"
        zIndex="var(--z-index-navbar-tabs)"
        top={tabHeight}
        borderTop="1px solid var(--chakra-colors-gray-400)"
        borderBottom={
          !isReactNativeApp
            ? "1px solid var(--chakra-colors-gray-400)"
            : undefined
        }
        backgroundColor="bg"
      >
        {selectedTab !== undefined && (
          <Box
            position="sticky"
            w="full"
            mx="auto"
            flexGrow={1}
            bg="bg"
            maxWidth="container.content"
          >
            <CallToAction
              membershipGroupData={membershipGroupData}
              venue={venue}
              openModal={openModal}
              isSmallerThanSm={isSmallerThanSm}
            />
            <Grid h="full" width="full" templateColumns="repeat(5, 1fr)">
              <GridItem id={headerTabsId} colSpan={isTablet ? 5 : 3}>
                <HeaderTabs
                  tabOptionsList={membershipTabOptions}
                  selectedTab={selectedTab}
                  setSelectedTab={setSelectedTab}
                />
              </GridItem>
              <GridItem
                h="0"
                hidden={isTablet}
                colSpan={2}
                pl={{ base: "xs" }}
                pr={{ base: "3xl" }}
              >
                <HeaderAction
                  showText={showHeaderActionInfo}
                  titleText={membershipGroupData?.name}
                  onModalOpen={openModal}
                  membershipGroupData={membershipGroupData}
                  venue={venue}
                />
              </GridItem>
            </Grid>
          </Box>
        )}
      </Flex>
    </>
  );
}
